// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import './App.css';
import { AppModal } from './components/Modal';

// ----------------------------------------------------------------------

export default function App() {
  // console.log('Captcha key:', process.env.REACT_APP_GOOGLE_CAPTCHA_KEY);
  // console.log('API URL:', process.env.REACT_APP_API_URL);
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <AppModal />
          <ProgressBarStyle />
          <ScrollToTop />
          <Router />
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
